// Tammy 2023/02/17: only '/users' are in v2, other endpoints are v1
import { v2Url } from 'api/api-constants';
export const usersV2 = v2Url + '/users';
